import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { trans } from 'sharedKernel/i18n'
import {
  ActionCell,
  ActionMenuItem,
  ActionMenuPanel,
  ActionMenuTrigger,
  ActionMenuTippy,
} from 'domain/feature/hub/company/meeting-room/manage-meeting-room/MeetingRoomReservationsTable/styles'
import {
  ACTION_CONFIG,
  ACTIONS_BY_STATUS,
  ReservationAction,
} from 'domain/feature/hub/company/meeting-room/manage-meeting-room/MeetingRoomReservationsTable/constants'
import { IMeetingRoomSolicitationDetail } from './types'

interface SolicitationActionMenuProps {
  row: IMeetingRoomSolicitationDetail
  onViewDetails?: (row: IMeetingRoomSolicitationDetail) => void
  onEdit?: (row: IMeetingRoomSolicitationDetail) => void
  onApprove?: (row: IMeetingRoomSolicitationDetail) => void
  onReject?: (row: IMeetingRoomSolicitationDetail) => void
  onCancel?: (row: IMeetingRoomSolicitationDetail) => void
}

export const SolicitationActionMenu = ({
  row,
  onViewDetails,
  onEdit,
  onApprove,
  onReject,
  onCancel,
}: SolicitationActionMenuProps): JSX.Element | null => {
  const [visible, setVisible] = useState(false)
  const actions = ACTIONS_BY_STATUS[row.status] ?? []

  const closeMenu = (): void => setVisible(false)

  const handleAction = (action: ReservationAction): void => {
    switch (action) {
      case 'edit':
        onEdit?.(row)
        break
      case 'approve':
        onApprove?.(row)
        break
      case 'reject':
        onReject?.(row)
        break
      case 'cancel':
        onCancel?.(row)
        break
      case 'viewDetails':
        onViewDetails?.(row)
        break
    }
    closeMenu()
  }

  if (actions.length === 0) {
    return null
  }

  const menu = (
    <ActionMenuPanel>
      {actions.map(action => {
        const config = ACTION_CONFIG[action]
        return (
          <ActionMenuItem
            key={action}
            type="button"
            $variant={config.variant}
            onClick={() => handleAction(action)}
          >
            <FontAwesomeIcon icon={config.icon} />
            {trans(config.labelKey)}
          </ActionMenuItem>
        )
      })}
    </ActionMenuPanel>
  )

  return (
    <ActionCell>
      <ActionMenuTippy
        content={menu}
        visible={visible}
        onClickOutside={closeMenu}
        interactive
        placement="bottom-end"
        arrow={false}
        offset={[0, 4]}
        appendTo={() => document.body}
        zIndex={1060}
      >
        <ActionMenuTrigger
          type="button"
          aria-label={trans('meetingRoom.reservations.column.action')}
          aria-expanded={visible}
          onClick={() => setVisible(open => !open)}
        >
          <FontAwesomeIcon icon={['fas', 'ellipsis-vertical']} />
        </ActionMenuTrigger>
      </ActionMenuTippy>
    </ActionCell>
  )
}
